<template>
  <div class="text-center" style="max-width: 400px; margin: auto; padding: initial;">
    <div class="icon icon-primary">
    </div>
    <div class="description">
    </div>

    <div class="">
      <form role="form" @submit.prevent="handleSubmit">
        <card class="card-signup text-center" no-footer-line>
          <template slot="header">
            <h4 class="card-title">Register</h4>
          </template>

          <input
           style="margin-bottom: 10px;" class="w-100"
           v-model="login"
           @keyup="validateLogin()"
           :placeholder="this.locale.login + '*'"
          >

          <input
              style="margin-bottom: 10px;" class="w-100"
              v-model="password"
              :placeholder="this.locale.password + '*'"
              type="password"
              @keyup="validatePasswordConfirm()"
          >

          <input
              style="margin-bottom: 10px;" class="w-100"
              v-model="password_confirmation"
              :placeholder="this.locale.password_confirmation + '*'"
              type="password"
              @keyup="validatePasswordConfirm()"
          >

          <input
              style="margin-bottom: 10px;" class="w-100"
              v-model="first_name"
              :placeholder="this.locale.first_name + '*'"
          >

          <input
              style="margin-bottom: 10px;" class="w-100"
              v-model="last_name"
              :placeholder="this.locale.last_name + '*'"
          >

          <input
              style="margin-bottom: 10px;" class="w-100"
              v-model="email"
              :placeholder="this.locale.email + '*'"
              @keyup="validateEmail()"
          >

          <the-mask mask="######-####" style="margin-bottom: 10px;" class="w-100" v-model="pidn" @keyup.native="validatePidn()" placeholder="XXXXXX-XXXX*" />

          <the-mask mask="###" class="w-100" v-model="employment_number" @keyup.native="validateEmpNum()" v-bind:placeholder="locale.employment_number + '*'" />

          <checkbox class="text-left" v-model="terms_agreed">
            I agree to the <a>terms and conditions</a>.
          </checkbox>

          <i v-if="!pidn_valid">* {{ locale.personal_no }} {{locale.is_not_valid}}</i>
          <br>
          <i v-if="!email_valid">* {{ locale.email }} {{locale.is_not_valid}}</i>
          <br>
          <i v-if="!emp_num_valid">* {{ locale.employment_number }} {{locale.is_not_valid}}</i>
          <br>
          <i v-if="!login_valid">* {{ locale.login }} {{locale.is_not_valid}}</i>
          <br>
          <i v-if="!password_confirm_valid">* {{ locale.password_confirmation }} {{locale.is_not_valid}}</i>
          <br>

          <div class="d-flex justify-content-between">
            <n-button
                slot="footer"
                type="secondary"
                @click.native="getBack()"
                round
                size="lg"
            >
              {{ this.locale.get_back }}
            </n-button>

            <n-button
                slot="footer"
                type="primary"
                native-type="submit"
                :class="{disabled: !(checkRequiresOnAdd() && pidn_valid && emp_num_valid && login_valid && email_valid)}"
                round
                size="lg"
            >
              Get Started
            </n-button>
          </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import { Checkbox } from "src/components";
import formMixin from "@/mixins/form-mixin";
const url = process.env.VUE_APP_API_BASE_URL;
export default {
  components: {
    Checkbox,
  },
  mixins: [formMixin],
  data() {
    return {
      locale: '',

      login: '',
      users: [],
      first_name: '',
      last_name: '',
      employment_number: '',
      terms_agreed: false,
      pidn: '',
      email: '',

      pidn_valid: false,
      emp_num_valid: false,
      login_valid: false,
      email_valid: false,
      password_confirm_valid: true,

      password: null,
      password_confirmation: null,
      modelValidations: {
        name: {
          required: true,
        },
        email: {
          required: true,
          email: true,
        },
        password: {
          required: true,
          min: 8,
        },
        confirmPassword: {
          required: true,
          confirmed: "password",
        },
      },
    };
  },
  methods: {
    getBack() {
      return this.$router.push({path: '/components/clientWorkers'})
    },

    checkRequiresOnAdd() {
      return (this.password != '' && this.password_confirmation != '' && this.password == this.password_confirmation)
          && (this.first_name && this.last_name && this.pidn && this.login && this.terms_agreed);
    },

    validateEmail() {
      let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      let duplicated = [];
      duplicated = this.users.filter(elem => elem.email == this.email);
      this.email_valid = (regex.test(this.email) && duplicated.length === 0);
    },
    validatePidn() {
      let regex = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([-|+]{0,1})?(\d{3})(\d{0,1})$/;
      let duplicated = [];
      duplicated = this.users.filter(elem => elem.personal_id_no == this.pidn);
      this.pidn_valid = (this.pidn.match(regex) && duplicated.length === 0);
    },

    validateEmpNum() {
      let duplicated = [];
      duplicated = this.users.filter(elem => elem.employment_number == this.employment_number);
      this.emp_num_valid = (duplicated.length === 0 && this.employment_number && this.employment_number != '' && this.employment_number != null
          && this.employment_number.length === 3);

    },

    validateLogin() {
      let duplicated = [];
      duplicated = this.users.filter(elem => elem.login == this.login);
      this.login_valid = duplicated.length === 0;
    },

    validatePasswordConfirm() {
      this.password_confirm_valid = this.password === this.password_confirmation;
    },

    async handleSubmit() {
      let user_data = {
        'employment_number': this.employment_number,
        'first_name': this.first_name,
        'last_name': this.last_name,
        'login': this.login,
        'email': this.email,
        'personal_id_no': this.pidn,
        'password': this.password,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(user_data)
      };
      await fetch(url + "/register-worker", requestOptions)
          .then(response => {
            const user = {
              data: {
                type: "token",
                attributes: {
                  login: this.login,
                  password: this.password,
                },
              },
            };

            const requestOptions = {
              headers: {
                Accept: "application/vnd.api+json",
                "Content-Type": "application/vnd.api+json",
              },
            };
            this.$store.dispatch("login", { user, requestOptions });
          });
    },

    async getWorkers() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      fetch(url + '/list-workers-register', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            data.forEach(elem => {
              if (elem.employment_number)
              {
                if (elem.employment_number.toString().length === 1)
                  elem.employment_number = ('0' + elem.employment_number).slice(-3);
                if (elem.employment_number.toString().length === 2)
                  elem.employment_number = ('00' + elem.employment_number).slice(-3);
              }
              this.users.push(elem);
            })
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },
  },
  mounted() {
    this.locale = this.$getLocale();
    this.getWorkers();
  }
};
</script>
<style>
input {
  padding-left: 1rem;
  font-size: 12px;
  border-radius: 30px;
  border: 1px solid #E3E3E3;
  height: 2.5rem;
}

input:focus {
  border: 1px solid #f96332;
}
</style>
